import ReactGA from "react-ga4";
import { consentimentoAceito } from "../utils/consentimento";

let inicializado = false;

// Só inicializa com consentimento "aceito" (LGPD) e uma única vez.
export const initializeAnalytics = () => {
    if (inicializado || !consentimentoAceito()) return false;
    inicializado = true;
    ReactGA.initialize("G-7XZFHEZZTF"); // Única propriedade de Analytics
    return true;
};

// Rastreia visualizações de página, incluindo o hostname
export const trackPageView = () => {
    if (!inicializado || !consentimentoAceito()) return;
    const page = window.location.pathname + window.location.search;
    const hostname = window.location.hostname;

    ReactGA.send({
        hitType: "pageview",
        page, // Caminho da página
        hostname, // Subdomínio (ex: fatcat.app.br ou go.fatcat.app.br)
    });
};

// Rastreia eventos personalizados
export const trackEvent = (category, action, label, value) => {
    if (!inicializado || !consentimentoAceito()) return;
    ReactGA.event({
        category, // Categoria do evento
        action,   // Ação realizada
        label,    // Descrição ou rótulo (opcional)
        value,    // Valor associado ao evento (opcional)
    });
};

// Rastreia o subdomínio como uma dimensão personalizada
export const trackSubdomain = () => {
    if (!inicializado || !consentimentoAceito()) return;
    const hostname = window.location.hostname;

    ReactGA.set({
        customDimension1: hostname, // Crie a dimensão no GA e use-a aqui
    });
};

// Somente para testes
export const _resetAnalytics = () => {
    inicializado = false;
};
